<template lang="pug">
    #cnpj
        p SOCIEDADE TECNICA EDUCACIONAL DA LAPA S/A
        p CNPJ: 02.558.975/0001-65
</template>

<script>
export default {
    name: "component-cnpj"
}
</script>

<style lang="stylus" scoped src="./Cnpj.styl"></style>